import { Slice } from "features/morphing/state/parameterAtoms";

export const isNaturalSlice = (
  slice: Slice
) => {
  return (
    Number.isInteger(slice.start) && slice.start > 0 &&
    Number.isInteger(slice.stop) && slice.stop > 0
  );
};

export const isOrderedSlice = (
  slice: Slice
) => {
  return (
    isNaturalSlice(slice) &&
    slice.start <= slice.stop
  );
};

export const isValidSlice = (
  slice: Slice,
  maxValue: number | null
) => {
  if (maxValue === null) {
    return false;
  } else {
    return (
      isOrderedSlice(slice) &&
      0 < slice.start &&
      slice.stop <= maxValue
    );
  };
};
